'use client'
import { useLayout, useTranslations } from '@dustin-web/microsite-components/src/hooks'
import scrollToElement from '@dustin-web/microsite-components/src/utils/scroll-to-element'

import { ProductDigitalData } from '@dustin-web/product-components/src/utils/product-digital-data'
import ServiceIcon from '@dustin-web/microsite-components/src/icon/generated/service'

export default function SummaryButton() {
  const { header } = useLayout()
  const { translate } = useTranslations()
  const handleOnClick = () => {
    const el = document.getElementById('more-variants')
    if (el) {
      scrollToElement(el, header.height.px)
      ProductDigitalData.pushSelectedVariant('button_click', 'See other versions here')
    }
  }
  return (
    <button
      type="button"
      className="c-btn u-border-none u-pl-0 u-color-black u-mb-0"
      data-test-id="variant-button"
      onClick={handleOnClick}>
      <>
        <ServiceIcon className="i-20 i-multi-layered u-mr-8" />
        <span style={{ textDecoration: 'underline' }} className="">
          {translate('See_Other_Variants_Here')}
        </span>
      </>
    </button>
  )
}
